<template>
    <div class="container">

        <div class="card">
            <div class="card-header">
                <div class="row justify-content-md-center">
                    <div class="col-md-4">
                        <b-button type="button" class="btn btn-primary btn-tarefa btn-block" title="Adicionar Preço"
                            @click.prevent="financeiro_id = null;
                            $bvModal.show('OrdemServicoTabs') ">
                            <i class=" fa fa-dollar-sign"></i> ADICIONAR SERVIÇO
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="card col-md-4" v-for="(item, index) in financeiro" :key="item.id">
                <div class="
            d-flex
            align-items-center
            justify-content-between
            p-2
            card-title
          ">
                    #ID {{ item.id }} - {{ item.servico ? item.servico.nome : '' }}
                    <dropdown v-if="item.vendas.filter((venda) => venda.status_id == 11).length == 0">
                        <b-dropdown-item
                            @click="financeiro_id = item.id; $bvModal.show('OrdemServicoTabs')">Alterar</b-dropdown-item>
                        <b-dropdown-item @click="financeiro_id = item.id; cancel()">Cancelar</b-dropdown-item>
                    </dropdown>
                </div>
                <div class="card-body">
                    <ul class="list-group list-group-flush">
                        <li class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
              ">
                            Total
                            <strong>{{ item.total }}</strong>
                        </li>
                        <li class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
              ">
                            Valor Pago

                            <strong class="text-success">{{ item.totais.pagos }}</strong>
                        </li>
                        <li class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
              ">
                            Em aberto
                            <strong class="text-primary">{{ item.totais.restam }}</strong>
                        </li>
                        <li class="
                list-group-item
                d-flex
                justify-content-between
                align-items-center
              ">
                            Vencidos
                            <strong class="text-danger">{{ item.totais.vencidos }}</strong>
                        </li>
                    </ul>
                    <b-button variant="primary" v-if="item.vendas.filter((venda) => venda.boleto_barato && venda.boleto_barato != null).length"
                        @click="vendas = item.vendas; $bvModal.show('showBoletos'); financeiro_id = item.id"><i class="fas fa-barcode"></i> Boletos</b-button>
                </div>
            </div>
        </div>

        <modal id="showBoletos" size="md" :title="`Boletos #ID ${financeiro_id}`">
            <Boletos :vendas="vendas"></Boletos>
        </modal>

        <modal id="OrdemServicoTabs" title="Cadastro de Serviço" size="md">
            <OrdemServicoTabs :cliente_id="cliente_id" :tarefa_id="tarefa_id" :financeiro_id="financeiro_id">
            </OrdemServicoTabs>
        </modal>
    </div>
</template>

<script>

import OrdemServicoTabs from "./forms/OrdemServicoTabs.vue";
import { mapMutations, mapState } from "vuex";
import Boletos from "./Boletos.vue";
export default {
    components: { OrdemServicoTabs, Boletos },
    data() {
        return {
            vendas: null,
            financeiro_id: null,
            financeiro: [],
        };
    },
    props: {
        tarefa_id: Number,
        cliente_id: Number,
    },
    computed: {
        ...mapState("modal", ["currentModal"]),
    },
    created() {
        this.$root.$on("reloadServicos", () => {
            this.getServicos();
        });
        this.getServicos();
    },
    methods: {
        ...mapMutations("modal", ["setCurrentModal"]),
        async getServicos() {
            const result = await this.$api.get(`tarefa/servicos/${this.tarefa_id}`);
            this.financeiro = result.data;
        },

        cancel() {
            this.$swal({
                title: `Cancelar cobranças?`,
                html: `<p>A cobrança id <b>${this.financeiro_id}</b> será cancelada e deixará de lhe ser cobrado qualquer valor.</p>`,
                showDenyButton: true,
                confirmButtonText: "Cancelar Cobrança",
                denyButtonText: `Manter Cobrança`,
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !this.$swal.isLoading(),
                preConfirm: () => {
                    return this.$api
                        .delete(`financeiro/${this.financeiro_id}`)
                        .then((response) => {
                            if (response.status != 200) {
                                throw new Error("Ocorreu um erro inesperado");
                            }



                            return response.data;
                        })
                        .catch((error) => {
                            this.$swal.showValidationMessage(
                                `Serviço temporariamente indisponivel: ${error}`
                            );
                        });
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    this.getServicos();
                    console.log("cancelado com sucesso!");
                }
            });
        },

    }
}
</script>
